import { combineReducers } from 'redux';
import submissions from './submissions';
import catalogItems from './catalogItems';
import user from './user';
import events from './events';
import providerList from './providerList';
import StoreProducts from './storeProducts';
import companyLogo from './companyLogo';
import Clients from './clients';
import Documents from './documents';
import Projects from './projects';
import dashboard from './dashboard';
import invitation from './invitation';
import LookupValues from './lookupValues';
import Reminders from './reminders';
import ReminderRules from './reminderRules';
import ClientActivities from './clientActivities';
import ProjectPlanning from './projectPlanning';
import BidRequests from './bidRequests';
import assemblies from './assemblies';

const appReducer = combineReducers({
  submissions,
  catalogItems,
  assemblies,
  user,
  events,
  providerList,
  companyLogo,
  StoreProducts,
  Clients,
  Documents,
  Projects,
  dashboard,
  invitation,
  LookupValues,
  Reminders,
  ReminderRules,
  ClientActivities,
  ProjectPlanning,
  BidRequests,
});

// Déconnexion : on repart d'un état ENTIÈREMENT neuf. Aucune liste (projets,
// clients, fournisseurs, rappels…) ne doit survivre à un changement de compte —
// sinon l'utilisateur suivant peut voir les données du précédent.
const rootReducer = (state, action) => appReducer(
  action.type === 'REMOVE_USER' ? undefined : state,
  action,
);

export default rootReducer;
